import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import InfoIcon from './InfoIcon';
import { useValidation } from './ValidationContext';

const validationRules = {
  required: value => ({
    isValid: value.trim() !== '',
    message: 'Pflichtfeld – bitte ankreuzen.'
  }),
  optional: value => ({
    isValid: value.trim() !== 'undefined',
    message: 'Pflichtfeld – bitte ankreuzen.'
  }),
};

const CustomCheckbox = forwardRef(({ rules, label, style, children, formData, onchange, sendChat, ...props }, ref) => {
  const [value, setValue] = useState('');
  const [errors, setErrors] = useState([]);
  const [validationContextError, setValidationContextError] = useState([]);
  const { registerValidator } = useValidation();

  useEffect(() => {
    //console.log("CustomCheckbox ref:", ref);
  }, [ref]);

  // Assign validateField method to ref so that it can be accessed in parent
  useImperativeHandle(ref, () => ({
    validateField
  }));

  const validateField = (new_value = value) => {
    //console.log("validateField in CustomCheckbox");
    //console.log('new_value: ', new_value);
    //console.log('value: ', value);
    //console.log('label: ', label);

    setErrors([]); // Reset errors

    const newErrors = rules.map(rule => {
        const { ruleKey, ruleParam, customRule } = rule;
        let validationRule = customRule;
        if (!validationRule && ruleKey) {
            validationRule = validationRules[ruleKey];
            if (typeof ruleParam !== 'undefined') {
                validationRule = validationRule(ruleParam);
            }
        }

        if (validationRule) {
            //console.log("VALUE BEFORE CHECK: " + new_value);
            const validationResponse = validationRule(new_value);
            if (!validationResponse.isValid) {
                return validationResponse.message;
            }
        }
        return null;
    }).filter(error => error !== null);

    setErrors(newErrors);
    //console.log('newErrors: ', newErrors);
    return newErrors.length === 0;
  };

  useEffect(() => {
      if (!rules || rules.length === 0) {
          throw new Error("CustomCheckbox requires 'rules' prop with at least one rule.");
      }
  }, [rules, value]);

  useEffect(() => {
    //console.log('validator for field: ', props.name);
    registerValidator(validateField);
  }, []);

  const handleChange = (event) => {
      const newValue = event.target.checked ? '1' : '';
      setValue(newValue);
  };

  // Trigger validateField when value changes
  useEffect(() => {
      validateField();
  }, [value]);

  return (
    <>
      <div className="inputField" style={{paddingTop: '15px'}}>
          <div className="form-check" style={{justifyItems: 'end'}}>
              <input type="checkbox" {...props} ref={ref} value={value} defaultChecked={(formData && formData[props.name]) || ""} className="form-check-input" placeholder={label} onChange={handleChange} />
              <label className="form-check-label" htmlFor={props.id}>{label}</label>
              {errors.map((error, index) => (
                  <div key={index} className="error-message error-message-checkbox">{error}</div>
              ))}
          </div>
      </div>

      <div className='info-wrapper'>
        {sendChat &&
        <InfoIcon
          onClick={() => {
              //console.log("Mouse entered");
              if (formData && formData['info'] && formData['info'][props.name]) {
                  sendChat(formData['info'][props.name]); // Call sendChat with the correct data
              }

              // Scroll to the element with ID #info-icon-container
              const element = document.getElementById('hilfe');
              if (element) {
                  element.scrollIntoView({ behavior: 'smooth' }); // Smooth scroll to the element
              }
          }}
      >
          {formData && (formData['info'] && formData['info'][props.name]) || ""}
      </InfoIcon>}
      </div>
    </>
  );
});

export default CustomCheckbox;
